export { default } from './FeaturedColab'